import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { BottomNavbarComponent, OrAvatarComponent, PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { GetTopRankQueryHandler, GetTopRankQueryResult } from '../../application/handlers';
import { Router } from '@angular/router';
import { AppRoutes, RankRoutes } from '@core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-total-rank',
  templateUrl: './total-rank.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, BottomNavbarComponent, OrAvatarComponent, PageLayoutComponent],
  providers: [GetTopRankQueryHandler]
})
export class TotalRankComponent {
  private readonly getTopRankQueryHandler: GetTopRankQueryHandler = inject(GetTopRankQueryHandler);
  private readonly router: Router = inject(Router);

  readonly topRank: Signal<GetTopRankQueryResult | undefined> = toSignal(this.getTopRankQueryHandler.getTopRank());

  goToRankQA(): void {
    this.router.navigateByUrl(`${AppRoutes.RANK}/${RankRoutes.QA}`);
  }
}
